<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            :main-title="this.$t('userForOpenbadgeV3.section1.texts.text1-1')"
            :sub-title="this.$t('userForOpenbadgeV3.section1.texts.text1-2')"
            bg-color="yellow3"
        />

        <section class="c-section bg-yellow3 d-flex justify-center">
            <div class="c-contanier">
                <v-row>
                    <v-col
                        cols="12"
                        md="11"
                        lg="10"
                        class="mx-auto"
                        :class="{
                            'd-flex align-start justify-space-between': $vuetify.breakpoint.mdAndUp,
                        }"
                    >
                        <!-- 발행자 로그인 -->
                        <div
                            style="flex: 1 1 50%;"
                            :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '384px' : '' }"
                            class="d-flex flex-column align-center justify-center"
                        >
                            <p 
                                class="le-heading4" 
                                :class="{
                                    'mb-6': $vuetify.breakpoint.mdAndUp,
                                    'mb-5': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                {{ this.$t('userForOpenbadgeV3.section2.texts.text1-1') }}
                            </p>

                            <div>
                                <v-img
                                    :src="require('@/assets/img/user-for-openbadge-v3-1.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 384 : ($vuetify.breakpoint.smOnly ? 360 : 300)"
                                    contain
                                    alt=""
                                />
                            </div>
                            
                            <p
                                class="le-text-body1 text-center"
                                :class="{
                                    'mt-10': $vuetify.breakpoint.mdAndUp,
                                    'mt-9': $vuetify.breakpoint.smOnly,
                                    'mt-6': $vuetify.breakpoint.xsOnly
                                }"
                            >
                                {{ this.$t('userForOpenbadgeV3.section2.texts.text1-2') }}
                            </p>

                            <div
                                :class="{
                                    'mt-15': $vuetify.breakpoint.mdAndUp,
                                    'mt-12': $vuetify.breakpoint.smOnly,
                                    'mt-10': $vuetify.breakpoint.xsOnly
                                }"
                                class="d-flex gap-7"
                            >
                                <v-btn
                                    href="https://issuer-kr.openbadge.net/"
                                    target="_blank"
                                    color="orange1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadgeV3.section2.btns.btn1') }}
                                </v-btn>

                                <v-btn
                                    href="https://www.notion.so/LecoS-OPEN-Badges-3-0-206be54b98a38073b5c7f3ac90f92245"
                                    target="_blank"
                                    color="blue1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadgeV3.section2.btns.btn2') }}
                                </v-btn>
                            </div>
                        </div>

                        <!-- 수령자 로그인 -->
                        <div
                            style="flex: 1 1 50%;"
                            :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '384px' : '' }"
                            class="d-flex flex-column align-center justify-center"
                            :class="{
                                'mt-22': $vuetify.breakpoint.smAndDown
                            }"
                        >
                            <p 
                                class="le-heading4" 
                                :class="{
                                    'mb-6': $vuetify.breakpoint.mdAndUp,
                                    'mb-5': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                {{ this.$t('userForOpenbadgeV3.section2.texts.text2-1') }}
                            </p>

                            <div>
                                <v-img
                                    :src="require('@/assets/img/user-for-openbadge-v3-2.png')"
                                    :width="$vuetify.breakpoint.mdAndUp ? 384 : ($vuetify.breakpoint.smOnly ? 360 : 300)"
                                    alt=""
                                />
                            </div>
                            
                            <p
                                class="le-text-body1 text-center"
                                :class="{
                                    'mt-10': $vuetify.breakpoint.mdAndUp,
                                    'mt-9': $vuetify.breakpoint.smOnly,
                                    'mt-6': $vuetify.breakpoint.xsOnly
                                }"
                            >
                                {{ this.$t('userForOpenbadgeV3.section2.texts.text2-2') }}
                            </p>

                            <div
                                :class="{
                                    'mt-15': $vuetify.breakpoint.mdAndUp,
                                    'mt-12': $vuetify.breakpoint.smOnly,
                                    'mt-10': $vuetify.breakpoint.xsOnly
                                }"
                                class="d-flex gap-7"
                            >
                                <v-btn
                                    href="https://wallet-kr.openbadge.net/"
                                    target="_blank"
                                    color="orange1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadgeV3.section2.btns.btn1') }}
                                </v-btn>

                                <v-btn
                                    href="https://concise-boat-d4b.notion.site/LecoS-OPEN-Badges-3-0-21ebe54b98a380168064fed89be41367?source=copy_link"
                                    target="_blank"
                                    color="blue1"
                                    :small="$vuetify.breakpoint.smAndDown"
                                    depressed
                                    class="text-white1"
                                >
                                    {{ this.$t('userForOpenbadgeV3.section2.btns.btn3') }}
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
// import { getLoginMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'AboutPage',
    components: {
        PageTitle
    },

    // metaInfo() {
    //     return getLoginMetaInfo(this);
    // },

    // SECTION: Data Properties
    data: function () {
        return {
            //
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    created() {
        //
    },

    mounted() {
        //
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        /* ============================================================
         * ANCHOR: 주석
         * ============================================================ */
        //
    },
    // !SECTION: Methods
};
</script>
